import React, { useState } from 'react';
import TabComponent from '../../components/TabComponent';
import { UnpledgedSalesIndex } from './UnpledgedSales';
import CashDisbursementsIndex from './CashDisbursement';
import SalesApprovalsIndex from './SalesApproval';
import SalesIndex from '../Sales';
import SalePaymentsIndex from './SalePayments';
import SalePaymentsApprovalIndex from './SalePaymentsApproval';

export const SalesAllIndex = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const role: string | null = localStorage.getItem('role');

  let tabOptions = [
    {
      to: '',
      label: 'Sales Form',
      index: 0,
    },
    {
      to: '',
      label: 'Unpledged Sales',
      index: 1,
    },
  ];

  if (role === 'approver') {
    tabOptions = [
      {
        to: '',
        label: 'Sales Approvals',
        index: 0,
      },
      {
        to: '',
        label: 'Sale Payment Approvals',
        index: 1,
      },
    ];
  }

  if (role === 'cashier') {
    tabOptions = [
      {
        to: '',
        label: 'Cash Disbursements',
        index: 0,
      },
      {
        to: '',
        label: 'Sale Payments',
        index: 1,
      },
      {
        to: '',
        label: 'Unpledged Sales',
        index: 2,
      },
    ];
  }

  if (role === 'manager' || role === 'superadmin') {
    tabOptions.push({
      to: '',
      label: 'Sales Approvals',
      index: 2,
    });
  }

  return (
    <div className="loan__all__page">
      <div className="title">
        <h1>Sales</h1>
      </div>
      <div className="">
        <TabComponent
          taboptions={tabOptions}
          selectedTab={selectedIndex}
          setSelectedTab={setSelectedIndex}
        />
      </div>
      <div className="main__container">
        {role === 'approver' ? (
          <>
            {selectedIndex === 0 && <SalesApprovalsIndex />}
            {selectedIndex === 1 && <SalePaymentsApprovalIndex />}
          </>
        ) : (
          <>
            {selectedIndex === 0 &&
              (role === 'cashier' ? <CashDisbursementsIndex /> : <SalesIndex />)}
            {selectedIndex === 1 &&
              (role === 'cashier' ? (
                <SalePaymentsIndex />
              ) : (
                <UnpledgedSalesIndex />
              ))}

            {selectedIndex === 2 &&
              (role === 'cashier' ? (
                <UnpledgedSalesIndex />
              ) : (
                <SalesApprovalsIndex />
              ))}
          </>
        )}
      </div>
    </div>
  );
};
